/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAlertReconciliation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAlertReconciliation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAlertReconciliation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAlertReconciliation>): BackgroundJobPayloadForAlertReconciliation {
        let obj = Object.assign(new BackgroundJobPayloadForAlertReconciliation(), model);
        BackgroundJobPayloadForAlertReconciliation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAlertReconciliation>): BackgroundJobPayloadForAlertReconciliation {
        if (!model) return null;
        return BackgroundJobPayloadForAlertReconciliation.newInstance(<BackgroundJobPayloadForAlertReconciliation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAlertReconciliation) {
        if (!obj) return;

        models.BackgroundJobPayloadForAlertReconciliation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAlertReconciliation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAlertReconciliation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the service account to reconcile alerts for
     */
    service_account_id: string;

}
